/* eslint-disable no-unused-vars */
import React, { FC, memo, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton
} from '@material-ui/core';
import { modifyPdf } from 'src/hooks/tax-certificate/modifyPdf';
import CloseIcon from '@material-ui/icons/Close';
import { TaxCertificateData } from 'src/redux/slices/purchase-order/types';

interface Props {
  handleClose: () => void;
  open: boolean;
  pdfData?: TaxCertificateData;
}

const component: FC<Props> = ({ handleClose, open, pdfData }) => {
  const { modification, pdfUrl, isLoading } = modifyPdf();

  useEffect(() => {
    if (open) {
      modification(pdfData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Typography variant="h5">Tax Certification - 2307 Form</Typography>
        <IconButton
          aria-label="close"
          style={{ position: 'absolute', right: 5, top: 5 }}
          color="secondary"
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        style={{
          height: '90vh',
          padding: 10
        }}
      >
        {pdfUrl ? (
          <iframe
            src={pdfUrl || ''}
            title="Modified PDF"
            style={{ width: '100%', height: '98%', border: 'none' }}
          />
        ) : (
          <p style={{ textAlign: 'center' }}>
            {isLoading ? 'Loading PDF...' : 'Click "Modify PDF" to start.'}
          </p>
        )}
      </DialogContent>
    </Dialog>
  );
};

export const TaxCertificationPDFDialog = memo(component);
